import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ToastService} from "@core/services/toast.service";
import {HttpService} from "@core/services/http.service";
import {ApplicationRole} from "@core/enumerations/application-role.enum";
import {BehaviorSubject, catchError} from "rxjs";
import {AuthService} from '@core/services/auth.service';
import {User} from "@core/models/user.model";
import { RuntimeEnvironmentService } from '../runtime-environment.service';

@Injectable({
  providedIn: 'root'
})
export class ApiAuthService extends HttpService<ApplicationRole> {
  currentUser$ = new BehaviorSubject<User | null>(null);

  constructor(
    http: HttpClient,
    toastService: ToastService,
    authService: AuthService,
    runtimeEnv: RuntimeEnvironmentService,
  ) {
    super(http, toastService, authService, runtimeEnv, 'auth')
  }

  setRoles() {
    this.http.get<ApplicationRole[]>(this.buildUrl('roles'))
      .pipe(
        catchError((error) => this.handleError(error))
      )
      .subscribe((roles: ApplicationRole[]) => {
        localStorage.setItem('ROLE', JSON.stringify(roles));
      });
  }

  getStoredRoles(): ApplicationRole[] | null {
    const rolesString = localStorage.getItem('ROLE');
    return rolesString ? JSON.parse(rolesString) : null;
  }

  authorized() {
    return this.http.get<boolean>(this.buildUrl('authorized'))
      .pipe(
        catchError((error) => this.handleError(error))
      )
  }

  getCurrentUser() {
    this.http.get<User>(this.buildUrl())
      .pipe(
        catchError((error) => this.handleError(error))
      ).subscribe((user: User) => {
      this.currentUser$.next(user);
    });
  }
}
